import { Autocomplete } from '@cast/design-system';

import { useWoopWorkloadFilters } from 'features/workload-optimization';

import { namespaceCriterion } from '../searchCriteria';

import { useSearchCriterion } from '@cast/shared-search-ui';

type Props = {
  optimizedOnly?: boolean;
};

export const NamespacesFilter = (props: Props) => {
  const { data } = useWoopWorkloadFilters({
    optimizedOnly: props.optimizedOnly,
  });
  const { setValue, value, clear } = useSearchCriterion(namespaceCriterion);
  const namespaces = data?.namespaces ?? [];

  return (
    <Autocomplete
      inputText="Namespaces"
      options={namespaces}
      value={value}
      onChange={(value) => {
        if (value?.length) {
          setValue?.(value);
        } else {
          clear?.();
        }
      }}
      searchFilter={(item, inputValue) =>
        item.toLowerCase().includes(inputValue.toLowerCase())
      }
      multiple
      checkable
      listSx={{ '& .MuiListItemText-primary': { whiteSpace: 'nowrap' } }}
      size="sm"
      testId="namespaces-filter"
    />
  );
};
